import { getScreenCartItemHelper } from 'clients/WebServiceClient';
import { createContext, useContext, useEffect, useState } from 'react';

export const CartSuggestionsContext = createContext();

export const CartSuggestionsProvider = (props) => {
  const [comboSuggestions, setComboSuggestions] = useState({});

  async function fetchCartItemHelper() {
    const res = await getScreenCartItemHelper();
    if (res.status !== 'OK') {
      console.error('[Error] load combo suggestion', res);
      return;
    }

    const comboSuggestions = {};
    (res.data || []).forEach((suggestion) => {
      comboSuggestions[suggestion.sku] = suggestion.helpers;
    });
    setComboSuggestions(comboSuggestions);
  }

  useEffect(() => {
    fetchCartItemHelper();
  }, []);

  return <CartSuggestionsContext.Provider value={{ comboSuggestions }}>{props.children}</CartSuggestionsContext.Provider>;
};

export const useCartSuggestions = () => useContext(CartSuggestionsContext);
